<template>
  <div class="row p-3">
    <h1>Veranstaltungsort</h1>
    <template v-if="hasSelectedLocation">
      <div class="col-12 mb-4">
        <div class="border bg-white p-3">
          <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-start gap-3">
            <div>
              <div class="text-uppercase text-muted small fw-semibold mb-2">Ausgewählter Veranstaltungsort</div>
              <div class="fw-semibold">{{ selectedLocationLabel }}</div>
              <div v-if="selectedLocationAddress" class="text-muted mt-1">{{ selectedLocationAddress }}</div>
            </div>
            <button class="btn btn-sm btn-outline-secondary" @click.prevent="resetLocation">ändern</button>
          </div>
        </div>
      </div>
      <div class="col-12 mb-3">
        <div class="col-12 mb-4 ps-0">
          <h5 class="card-title">Sind Sie Inhaber des Veranstaltungsortes?</h5>
        </div>

        <Field as="select" v-model="surveyStore.data.veranstaltung.inhaber" id="veranstaltung_inhaber"
               name="veranstaltung_inhaber" class="form-select" :class="{'is-invalid': errors.veranstaltung_inhaber}">
          <option value="">--- bitte auswählen ---</option>
          <option value="true">Ja</option>
          <option value="false">Nein</option>
        </Field>
      </div>
      <div class="col-12" v-if="surveyStore.data.veranstaltung.inhaber === 'ja'">

        <Field type="checkbox" name="veranstaltung_ort">
          <div class="form-check" :key="radio.key" v-for="radio in radios">
            <input type="radio" v-model="surveyStore.data.veranstaltung.ort_typ" :value="radio.key" :id="radio.key"
                   class="form-check-input"/>
            <label class="form-check-label" :for="radio.key">
              {{ radio.label }}
            </label>
          </div>
        </Field>
      </div>

    </template>
    <template v-else>
      <ErrorMessage name="veranstaltung_termin" class="font-bold my-2"/>
      <!--      <h5 class="card-title mt-4">Name des Veranstaltungsortes</h5>-->
      <!--      <Field type="input" v-model="surveyStore.data.veranstaltung.ort_name" name="veranstaltung_ort_name" id="veranstaltung_ort_name" class="form-control">-->
      <!--      </Field>-->
      <div class="col-12"> <!--  v-if="surveyStore.data.veranstaltung.inhaber === '' -->
        <Standort :errors="errors" v-model="surveyStore.data.standort"/>
      </div>
    </template>
  </div>
</template>

<script>
import {useSurveyStore} from "@/stores/survey";
import {Field, ErrorMessage} from 'vee-validate';
import Standort from "@/components/general/Standort.vue";
import dayjs from "dayjs";

export default {
  components: {
    Field,
    ErrorMessage,
    Standort,
  },
  setup() {
    return {
      surveyStore: useSurveyStore(),
    }
  },
  data() {
    return {
      min: dayjs().toISOString().split(".")[0],
      max: dayjs().add(1, 'year').toISOString().split(".")[0],
      standort_manuell: false,
      radios: [
        {
          key: 'theater',
          label: 'Theater'
        },
        {
          key: 'museum',
          label: 'Museum'
        },
        {
          key: 'bar',
          label: 'Bar'
        },
        {
          key: 'allgemeiner_ort',
          label: 'Allgemeiner Ort für Veranstaltungen (z.B. Saal, Platz, Wiese, Club, Bühne)'
        },
        {
          key: 'kino',
          label: 'Kino'
        },
        {
          key: 'festspielort',
          label: 'Festspielort'
        },
        {
          key: 'windmuehle',
          label: 'Windmühle'
        },
        {
          key: 'gutshaus',
          label: 'Gutshaus'
        },
        {
          key: 'schloss',
          label: 'Schloss'
        },
        {
          key: 'burg',
          label: 'Burg'
        },
        {
          key: 'hotel',
          label: 'Hotel'
        },
        {
          key: 'kirche_kloster',
          label: 'Kirche / Kloster'
        },
        {
          key: 'historische_str_platz_markt',
          label: 'Historische Straße / Platz / Markt'
        },
        {
          key: 'erlebnishof_park',
          label: 'Erlebnishof / -park'
        },
        {
          key: 'zoo_tierpark',
          label: 'Zoo / Tierpark'
        },
        {
          key: 'erlebnisbad_thermen',
          label: 'Erlebnisbäder / -thermen'
        },
      ]
    }
  },
  props: {
    errors: Object,
  },
  methods: {
    resetLocation() {
      this.surveyStore.data.standort = {}
      this.surveyStore.data.veranstaltung.inhaber = ''
      this.surveyStore.data.veranstaltung.ort_typ = ''
    },
  },
  computed: {
    selectedLocation() {
      return this.surveyStore.data.standort || {}
    },
    hasSelectedLocation() {
      return Boolean(this.selectedLocation.id)
    },
    selectedLocationLabel() {
      return this.selectedLocation.name || this.selectedLocation.street || 'Veranstaltungsort'
    },
    selectedLocationAddress() {
      if (this.selectedLocation.address_string) {
        return this.selectedLocation.address_string
      }

      return [
        this.selectedLocation.street,
        [this.selectedLocation.postcode, this.selectedLocation.city].filter(Boolean).join(' ')
      ].filter(Boolean).join(', ')
    },
  },

}
</script>

<style scoped lang="scss">
@media (max-width: 767.98px) {
  .btn {
    width: 100%;
  }
}
</style>
